import { render } from "./Produtos.vue?vue&type=template&id=34bddbfe&scoped=true"
import script from "./Produtos.vue?vue&type=script&lang=js"
export * from "./Produtos.vue?vue&type=script&lang=js"

import "./Produtos.vue?vue&type=style&index=0&id=34bddbfe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-34bddbfe"

export default script